module.exports = __webpack_public_path__ + "img/lw-type.f867d4f0.jpg";